/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/ap-intro",
  DASHBOARD: "/ap-dashboard",
  INBOX: "/ap-inbox",
  OUTBOX: "/ap-outbox",

  /* Master */

  VIEWNOTIFI: "/notification",
  AP_SUPPLIER_LIST: "/ap-supplier-list",
  AR_CUSTOMER_LIST: "/ar-customer-list",

  AP_INVOICE_LIST: "/ap-invoice-list",
  AR_INVOICE_LIST: "/ar-invoice-list",

  AP_PURCHASE_ORDER: "/ap-purchase-order",
  AR_SALES_ORDER: "/ar-sales-order",

  AP_INVOICE_AUTO_CREATE: "/ap-invoice-auto-creater",
  AR_INVOICE_AUTO_CREATE: "/ar-invoice-auto-creater",

  AP_INV_DETAIL: "/ap-invoice-details",
  AR_INV_DETAIL: "/ar-invoice-details",

  BUDGET_CARDS: "/budget",
  BUDGET_LIST: "/budget-list",

  AP_SUPPLIER_CREATE: "/supplier-create-ap",

  AR_CUST_CREATE: "/ar-customer-creation",
  AR_CUST_DETAIL: "/ar-customer-detail",

  AP_PAYMENT_OUT: "/ap-payment-out",
  AR_PAYMENT_IN: "/ar-payment-in",
  AP_WORK_FLOW: "/ap-workflow",
  AP_CREATE_PO: "/ap-create-po",
  AP_PO_DETAILS: "/ap-details-po",
  AR_CREATE_SO: "/ap-create-so",


  /* Master */     
  AP_EXP_INV_CREATE: "/ap-exp-invoice",
  AP_EXP_INV_LIST: "/ap-exp-list",
  AP_EXP_INV_DETAILS: "/ap-exp-details",
  AP_EXP_PAY_OUT: "/ap-exp-payout",

  //reports
  AP_AUTO_REPORTS:"/ap-reports",
  AP_AUTO_REPORTS_DETAIL:"/ap-reports-details",

});
